import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle, FiFacebook, FiCheckCircle } = FiIcons;

export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-brand-cream relative overflow-hidden">
      <div className="absolute -bottom-20 -right-20 opacity-5 pointer-events-none">
        <SafeIcon icon={FiMessageCircle} className="text-[30rem] text-brand-brown" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-5xl md:text-7xl font-black text-brand-brown uppercase mb-8 tracking-tighter italic">
          Is Your Trade <br className="md:hidden"/> Still Open?
        </h2>

        <p className="text-2xl text-brand-brown/70 mb-16 max-w-2xl mx-auto font-bold leading-tight">
          Spots fill fast. Message me to check if your category is still available in your city.
        </p>

        <div className="bg-white border-[8px] border-brand-brown rounded-[3rem] p-12 md:p-20 shadow-[24px_24px_0px_#4A3320] group">
          <h3 className="text-3xl font-black text-brand-brown mb-8 uppercase tracking-tight italic">Message me directly — no forms, no wait.</h3>

          <div className="flex flex-col gap-8 items-center">
            <a
              href="https://www.facebook.com/thegyrohero"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full max-w-md flex items-center justify-center gap-6 bg-[#1877F2] hover:bg-[#166FE5] text-white px-12 py-8 rounded-[2rem] font-black text-2xl uppercase transition-all shadow-2xl hover:scale-105 active:scale-95 border-b-[8px] border-black/20"
            >
              <SafeIcon icon={FiFacebook} className="text-4xl" /> Message Sean
            </a>
            <p className="text-brand-brown/50 font-black uppercase tracking-widest text-sm">
              Average response time: Under 1 hour
            </p>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center text-brand-blue">
                <SafeIcon icon={FiCheckCircle} className="text-2xl" />
              </div>
              <span className="font-black uppercase text-xs tracking-widest text-brand-brown/60 text-center">No Forms<br/>Required</span>
            </div>
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center text-brand-blue">
                <SafeIcon icon={FiCheckCircle} className="text-2xl" />
              </div>
              <span className="font-black uppercase text-xs tracking-widest text-brand-brown/60 text-center">Owner to<br/>Owner</span>
            </div>
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center text-brand-blue">
                <SafeIcon icon={FiCheckCircle} className="text-2xl" />
              </div>
              <span className="font-black uppercase text-xs tracking-widest text-brand-brown/60 text-center">Fast<br/>Booking</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
